<template>
    <nav aria-label="Page navigation">
        <ul class="pagination justify-content-center">
            <!-- Previous -->
            <li class="page-item" :class="{ disabled: currentPage === 1 }">
                <button type="button" class="page-link bg-transparent" :disabled="currentPage === 1"
                    aria-label="Previous page" @click="changePage(currentPage - 1)">
                    <i class="fa-solid fa-chevron-left"></i>
                </button>
            </li>

            <!-- First page -->
            <li v-if="showFirstPage" class="page-item">
                <button type="button" class="page-link" :aria-label="'Go to page 1'" @click="changePage(1)">
                    1
                </button>
            </li>

            <!-- Ellipsis (before) -->
            <li class="page-item disabled" v-if="showFirstEllipsis">
                <span class="page-link"><i class="fa-solid fa-ellipsis"></i></span>
            </li>

            <!-- Previous numbered page -->
            <li class="page-item" v-if="showPreviousPage">
                <button type="button" class="page-link" :aria-label="'Go to page ' + (currentPage - 1)"
                    @click="changePage(currentPage - 1)">
                    {{ currentPage - 1 }}
                </button>
            </li>

            <!-- Current page (active) -->
            <li class="page-item active">
                <button type="button" class="page-link" aria-current="page" disabled>
                    {{ currentPage }}
                </button>
            </li>

            <!-- Next numbered page -->
            <li class="page-item" v-if="showNextPage">
                <button type="button" class="page-link" :aria-label="'Go to page ' + (currentPage + 1)"
                    @click="changePage(currentPage + 1)">
                    {{ currentPage + 1 }}
                </button>
            </li>

            <!-- Ellipsis (after) -->
            <li class="page-item disabled" v-if="showLastEllipsis">
                <span class="page-link"><i class="fa-solid fa-ellipsis"></i></span>
            </li>

            <!-- Last page -->
            <li v-if="showLastPage" class="page-item">
                <button type="button" class="page-link" :aria-label="'Go to page ' + totalPages"
                    @click="changePage(totalPages)">
                    {{ totalPages }}
                </button>
            </li>

            <!-- Next -->
            <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                <button type="button" class="page-link bg-transparent" :disabled="currentPage === totalPages"
                    aria-label="Next page" @click="changePage(currentPage + 1)">
                    <i class="fa-solid fa-chevron-right"></i>
                </button>
            </li>
        </ul>
    </nav>
</template>

<script>
export default {
    name: 'ListPagination',
    props: {
        currentPage: { type: Number, required: true },
        totalTasks: { type: Number, required: true },
        limit: { type: Number, default: 10 }
    },
    emits: ['page-changed'],
    computed: {
        totalPages() {
            const pages = Math.ceil(this.totalTasks / this.limit) || 1;
            return pages < 1 ? 1 : pages;
        },
        showFirstPage() {
            return this.currentPage > 2;
        },
        showFirstEllipsis() {
            return this.currentPage > 3;
        },
        showPreviousPage() {
            return this.currentPage > 1;
        },
        showNextPage() {
            return this.currentPage < this.totalPages;
        },
        showLastEllipsis() {
            return this.currentPage < this.totalPages - 2;
        },
        showLastPage() {
            return this.currentPage < this.totalPages - 1;
        }
    },
    methods: {
        changePage(p) {
            const page = Number(p);
            if (!Number.isFinite(page)) return;
            const clamped = Math.min(Math.max(page, 1), this.totalPages);
            if (clamped === this.currentPage) return;
            this.$emit('page-changed', clamped);
        }
    }
};
</script>

<style scoped>
.pagination .page-item {
    margin-right: 8px;
    min-width: 36px;
    text-align: center;
    border-radius: 0.70rem;
}

.pagination .page-item:last-child {
    margin-right: 0;
}

.pagination .page-link {
    border-radius: 0.70rem;
}
</style>
